import { render, staticRenderFns } from "./ToReceiveTab.vue?vue&type=template&id=7fed7230&scoped=true&"
import script from "./ToReceiveTab.vue?vue&type=script&lang=js&"
export * from "./ToReceiveTab.vue?vue&type=script&lang=js&"
import style0 from "./ToReceiveTab.vue?vue&type=style&index=0&id=7fed7230&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fed7230",
  null
  
)

export default component.exports